<template>
    <div class="no-lab-banner-wr">
        <transition name="fade" appear>
            <div class="no-lab-banner-wr__desktop">
                <component
                    :is="tag"
                    class="no-lab-banner"
                    :class="{'js-no-lab-banner': userAuthorized, 'no-lab-banner--lk': !isCatalog}"
                    :data-toggle="linkToModal.toggle"
                    :data-target="linkToModal.target"
                    :href="href"
                    @click="addLab"
                >
                    <h3 class="no-lab-banner__title">Виртуальная кофе-лаборатория</h3>

                    <div class="no-lab-banner__content">
                        <p class="no-lab-banner__content-title">Лаборатория позволит:</p>

                        <ul>
                            <li>подобрать кофе, подходящий под ваше оборудование</li>
                            <li>получать рекомендации по улучшению оборудования</li>
                        </ul>

                        <p class="no-lab-banner__offer" v-if="!isCatalog">Заполните данные о вашем оборудование сейчас<br> и получите бонусы на оплату заказа.</p>
                    </div>

                    <span class="btn btn-main btn-sm btn-block no-lab-banner__action">Создать лабораторию</span>

                    <div class="no-lab-banner__spots">
                        <span v-for="item in 4" :key="item" class="no-lab-banner__spot pulse-spot"></span>
                    </div>
                </component>
            </div>
        </transition>

        <transition name="fade" appear>
            <div class="no-lab-banner-wr__mobile">
                <div
                    class="no-lab-banner"
                    :class="{
                            'js-no-lab-banner-mobile': isCatalog,
                            'no-lab-banner--open': !isCatalog,
                    }"
                >

                    <h3
                        class="no-lab-banner__title"
                        :class="{'js-banner-title': isCatalog}"
                    >
                        <span>Виртуальная кофе-лаборатория</span>
                        <svg v-if="isCatalog">
                            <use xlink:href="/sprite.svg#icon-chevron-collapse"></use>
                        </svg>
                    </h3>

                    <div class="no-lab-banner__content">
                        <p><strong>Лаборатория позволит:</strong></p>

                        <ul>
                            <li>подобрать кофе, подходящий под ваше оборудование</li>
                            <li>получать рекомендации по улучшению оборудования</li>
                        </ul>
                    </div>

                    <component
                        :is="tag"
                        class="no-lab-banner__spots"
                        :class="{'js-no-lab-banner': userAuthorized}"

                        :href="href"
                        @click="addLab"
                    >
                        <span v-for="item in 4" :key="item" class="no-lab-banner__spot pulse-spot"></span>
                    </component>

                    <div class="no-lab-banner__action">
                        <component
                            :is="tag"
                            class="btn btn-main btn-sm btn-block"
                            :data-toggle="linkToModal.toggle"
                            :data-target="linkToModal.target"
                            :href="href"
                            @click="addLab"
                        >
                            Создать лабораторию
                        </component>
                    </div>

                </div>
           </div>
        </transition>
    </div>
</template>

<script>

import { LAB_REDIRECT_URL, LAB_SAVE_URL } from '../../constants/labs';

export default {
    name: 'no-lab-banner',

    props: {
        isCatalog: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            fromCatalogUrl: '/register/',
            fromLkUrl: '/personal/lab/',
        };
    },

    computed: {
        userAuthorized() {
            return !!window.specialtyApp.userData?.ID;
        },

        linkToModal() {
            return {
                // toggle: !this.userAuthorized && this.isCatalog ? 'modal' : false,
                // target: !this.userAuthorized && this.isCatalog ? '#loginModal' : false,
                toggle: false,
                target: false,
            };
        },

        tag() {
            return this.isCatalog ? 'a' : 'div';
        },

        href() {
            let link = null;

            if (this.isCatalog) {
                link = this.userAuthorized ? this.fromLkUrl : this.fromCatalogUrl;
            }

            return link;
        },
    },

    methods: {
        addLab() {
            if (this.isCatalog) {
                localStorage.setItem(LAB_REDIRECT_URL, LAB_SAVE_URL);
                return;
            }

            window.location.href = this.fromLkUrl;
        },
    },

};
</script>
